<template>
    <v-app id="app">
        <router-view></router-view>
    </v-app>
</template>

<script>

import {useSecurityStore} from "@/stores/Security.js";
import {usePaySectionStore} from "@/stores/PaySection";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";
import useTools from "@/use/Tools";
import {onMounted, onUnmounted} from "vue";

export default {
    name: 'App',
    setup() {
        const {logout} = useSharedMethod();
        const {$swal} = useTools();
        
        const securityStore = useSecurityStore();
        const paySectionStore = usePaySectionStore();
        
        if (window.localStorage) {
            let localUserString = window.localStorage.getItem("userContext") || "null";
            let localUser = JSON.parse(localUserString);
            
            if (localUser && securityStore.userContext !== localUser) {
                securityStore.setUserContext(localUser);
                securityStore.setAccessToken(window.localStorage.getItem("accessToken"));
                securityStore.setVersion(window.localStorage.getItem("version"));
                securityStore.setServerAddress(window.localStorage.getItem("serverAddress"));
                securityStore.setServerPort(window.localStorage.getItem("serverPort"));
                securityStore.setAuthorities(JSON.parse(window.localStorage.getItem("authorities")));
                
                paySectionStore.findAll();
            }
        }
        
        let timerId = null;
        let failCount = 0;
        const MAX_FAILURES = 3;
        
        const testConnection = async () => {
            try {
                const response = await axios.get('/auth/testConnection');
                if (response.data === 'LOGOUT') {
                    logout();
                }
                return true;
            } catch (error) {
                if (!error.response) {
                    return false; // network error, no connection
                }
                return true; // server responded (even with error) = still connected
            }
        };
        
        const checkConnection = async () => {
            const ok = await testConnection();
            if (ok) {
                failCount = 0;
            } else {
                failCount++;
                if (failCount >= MAX_FAILURES) {
                    failCount = 0; // reset so it can re-trigger later if still failing
                    // alert('Veuillez vérifier votre connexion');
                    $swal('Veuillez vérifier votre connexion', '', 'error');
                }
            }
        };
        
        onMounted(() => {
            timerId = setInterval(checkConnection, 10000);
        });
        
        onUnmounted(() => {
            clearInterval(timerId);
            timerId = null;
        });
    },
};
</script>

<style>
@import './assets/css/hex_color.css';
</style>